import { useLanguage } from "@/context/LanguageContext";
import { DollarSign, Headphones, FileSignature, Mail } from "lucide-react";

const capabilities = [
  {
    key: "multiCurrency",
    icon: DollarSign,
    image: "/images/multi_currency.png",
    color: "bg-amber-50 text-amber-600",
  },
  {
    key: "communication",
    icon: Mail,
    image: "/images/communication_channels.png",
    color: "bg-sky-50 text-sky-600",
  },
  {
    key: "afterSales",
    icon: Headphones,
    image: "/images/after_sales_service.png",
    color: "bg-emerald-50 text-emerald-600",
  },
  {
    key: "contracts",
    icon: FileSignature,
    image: "/images/contract_management.png",
    color: "bg-violet-50 text-violet-600",
  },
];

export function CapabilitiesSection() {
  const { t } = useLanguage();

  return (
    <section data-testid="capabilities-section" className="py-20 sm:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-sm uppercase tracking-[0.2em] font-bold text-[#22A7D1]">
            {t("capabilities.overline")}
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight font-bold text-slate-900">
            {t("capabilities.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {capabilities.map((cap, i) => {
            const Icon = cap.icon;
            return (
              <div
                key={i}
                className="rounded-2xl border border-slate-200 bg-white hover:border-slate-300 hover:shadow-lg transition-all overflow-hidden group"
                data-testid={`capability-${cap.key}`}
              >
                <div className="grid sm:grid-cols-2 items-center">
                  <div className="p-6 sm:p-8">
                    <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${cap.color}`}>
                      <Icon className="w-5 h-5" />
                    </div>
                    <h3 className="text-lg font-bold text-slate-900 mb-2">
                      {t(`capabilities.${cap.key}`)}
                    </h3>
                    <p className="text-sm text-slate-500 leading-relaxed">
                      {t(`capabilities.${cap.key}Desc`)}
                    </p>
                  </div>
                  <div className="p-4 sm:p-0 sm:pr-4">
                    <div className="rounded-xl overflow-hidden">
                      <img
                        src={cap.image}
                        alt={`EntegrePanel - ${t(`capabilities.${cap.key}`)}`}
                        width="500"
                        height="320"
                        className="w-full h-auto group-hover:scale-[1.03] transition-transform duration-500"
                        loading="lazy"
                        decoding="async"
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
